export default __webpack_public_path__ + "static/media/ni.abd6373b.jpg";